import { useRef, useState, useEffect } from 'react';

var useAutoNavigation = function useAutoNavigation(_ref) {
  var autoNavigationDelay = _ref.autoNavigationDelay,
      carouselContainerRef = _ref.carouselContainerRef,
      currentSelection = _ref.currentSelection,
      length = _ref.length,
      scrollToSlide = _ref.scrollToSlide,
      setCurrentSelection = _ref.setCurrentSelection,
      setHasBeenInteracted = _ref.setHasBeenInteracted;
  var autoNavigationTimeoutRef = useRef(null);

  var _useState = useState(!!autoNavigationDelay),
      isAutoNavigatingActive = _useState[0],
      setIsAutoNavigatingActive = _useState[1];

  var ariaLive = isAutoNavigatingActive ? "off" : "polite";
  useEffect(function () {
    setIsAutoNavigatingActive(!!autoNavigationDelay);
  }, [autoNavigationDelay]);
  useEffect(function () {
    var resetAutoNavigationTimeout = function resetAutoNavigationTimeout() {
      if (autoNavigationTimeoutRef.current) {
        clearTimeout(autoNavigationTimeoutRef.current);
      }
    };

    resetAutoNavigationTimeout();

    if (isAutoNavigatingActive) {
      autoNavigationTimeoutRef.current = setTimeout(function () {
        var nextSlide = currentSelection === length - 1 ? 0 : currentSelection + 1;
        setCurrentSelection(nextSlide);
        scrollToSlide(nextSlide);
        setHasBeenInteracted(true);
      }, autoNavigationDelay);
    }

    return function () {
      resetAutoNavigationTimeout();
    };
  }, [autoNavigationDelay, scrollToSlide, currentSelection, isAutoNavigatingActive, length, setCurrentSelection, setHasBeenInteracted]);
  useEffect(function () {
    var currentCarouselContainer = carouselContainerRef.current;

    var disableAutoNavigation = function disableAutoNavigation() {
      setIsAutoNavigatingActive(false);
    };

    var enableAutoNavigation = function enableAutoNavigation() {
      setIsAutoNavigatingActive(true);
    };

    if (autoNavigationDelay) {
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.addEventListener("mouseover", disableAutoNavigation);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.addEventListener("focusin", disableAutoNavigation);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.addEventListener("touchstart", disableAutoNavigation);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.addEventListener("mouseleave", enableAutoNavigation);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.addEventListener("focusout", enableAutoNavigation);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.addEventListener("touchend", enableAutoNavigation);
    }

    return function () {
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.removeEventListener("mouseover", disableAutoNavigation);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.removeEventListener("focusin", disableAutoNavigation);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.removeEventListener("touchstart", disableAutoNavigation);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.removeEventListener("mouseleave", enableAutoNavigation);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.removeEventListener("focusout", enableAutoNavigation);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.removeEventListener("touchend", enableAutoNavigation);
    };
  }, [autoNavigationDelay, carouselContainerRef]);
  return {
    ariaLive: ariaLive,
    isAutoNavigatingActive: isAutoNavigatingActive
  };
};

export { useAutoNavigation as default };